import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAuth0 } from '@auth0/auth0-react';
import { clearGuestSession } from './useIsGuest';
import { Button } from '../ui';

export interface LockedOverlayProps {
  featureName: string;
  headline: string;
  benefit: string;
  children: React.ReactNode;
  ctaLabel?: string;
  onSignup?: () => void;
}

const LockedOverlay: React.FC<LockedOverlayProps> = ({
  featureName,
  headline,
  benefit,
  children,
  ctaLabel = 'Sign up to unlock',
  onSignup,
}) => {
  const { loginWithRedirect } = useAuth0();

  const handleSignup = () => {
    if (onSignup) return onSignup();
    clearGuestSession();
    loginWithRedirect({
      appState: { targetUrl: '/initial-setting' },
      authorizationParams: { screen_hint: 'signup' },
    });
  };

  return (
    <div className="relative h-full min-h-[480px] w-full overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          filter: 'blur(7px) saturate(0.85) brightness(0.7)',
          transform: 'scale(1.03)',
        }}
      >
        {children}
      </div>
      <div aria-hidden className="absolute inset-0 bg-[rgba(8,11,17,0.62)]" />
      <div
        role="dialog"
        aria-labelledby="locked-overlay-headline"
        className="absolute left-1/2 top-1/2 w-[420px] max-w-[calc(100%-32px)] -translate-x-1/2 -translate-y-1/2 rounded-[18px] border border-border bg-surface p-[38px_34px_32px] text-center font-sans shadow-[0_40px_110px_-40px_rgba(0,0,0,0.85)]"
      >
        <div className="mx-auto mb-5 grid h-[70px] w-[70px] place-items-center rounded-full border border-[rgba(39,182,203,0.3)] bg-[rgba(39,182,203,0.13)] text-cyan">
          <LockOutlinedIcon style={{ fontSize: 32 }} />
        </div>
        <div className="mb-[9px] text-[12.5px] font-bold uppercase tracking-[0.08em] text-cyan">
          {featureName}
        </div>
        <div
          id="locked-overlay-headline"
          className="text-[22px] font-bold tracking-[-0.01em] text-white"
        >
          {headline}
        </div>
        <div className="m-[11px_0_24px] text-[14px] leading-[1.55] text-muted">{benefit}</div>
        <Button variant="primary" size="lg" fullWidth onClick={handleSignup}>
          {ctaLabel}
        </Button>
      </div>
    </div>
  );
};

export default LockedOverlay;
